<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Etape</mat-label>
            <mat-select data-select-step formControlName="step" required tabindex="10">
                @for (item of _steps; track item) {
                    <mat-option data-select-listing-type-option [value]="item.data.id">
                        {{ item.data.stepName }}
                    </mat-option>
                }
            </mat-select>
            @if (dataForm.errors && dataForm.errors['step'].required && (dataForm.controls['step']?.dirty || dataForm.controls['step'].touched)) {
                <mat-error data-input-role-error>Le champ 'Etape' est obligatoire</mat-error>
            }
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Etape" matTooltipPosition="right"></fa-icon>
    </div>
</form>
